import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type FadeInProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function FadeIn({
  children,
  delay = 0,
  className
}: FadeInProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div initial={reduceMotion ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: reduceMotion ? 0 : 0.45,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-132">
      {children}
    </motion.div>;
}